import React, { useEffect } from "react";

const OverlayLoader = ({ loading }) => {
  // useEffect(() => {
  //   if (loading) {
  //     document.body.style.overflow = "hidden";
  //   }

  //   if (!loading) {
  //     document.body.style.overflow = "scroll";
  //   }
  // }, [loading]);

  if (!loading) return null;

  return (
    <div className="flone-preloader-wrapper-overlay">
      <div className="flone-preloader-overlay">
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default OverlayLoader;
